import React, { useEffect, useState } from "react";
import MainCard from "components/MainCard";
import { Table, Spin, Pagination, Button } from "antd";
import { connect } from "react-redux";
import { Grid } from "@mui/material";
import { IoMdAddCircle } from "react-icons/io";
import { dispatch } from "store/index";
import { allTeamsColumns } from "components/columns/columns";
import { FetchAllTeams } from "store/action/index";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import {
  can_add_teams,
  can_view_teams,
  can_edit_teams,
  can_delete_teams,
} from "helper/permissionsCheck";
const AllTeams = ({ allTeamsData }) => {
  const [loading, setLoading] = useState(true);
  const [params, setParams] = useState({ page: 1, team_id: localStorage.getItem("teams_id") });
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    dispatch(FetchAllTeams({ setLoading: setLoading, params: params }));
  }, [params]);

  const HandleEdit = (record) => {
    navigate("/teams/add-team", { state: record });
  };

  const columns = allTeamsColumns({ params, setParams });

  {
    can_edit_teams ? columns.push({
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Button onClick={() => HandleEdit(record)}>Edit</Button>
      ),
    }) : <></>
  };



  const handlePageChange = (page) => {
    setParams({ ...params, page });
  };

  return (
    <>
      {can_add_teams ? <div className="mb-4">
        <MainCard>
          <div style={{ display: "flex" }}>
            <Grid container alignItems="center" justifyContent="flex-start">
              <Grid item>
                <span
                  style={{
                    fontSize: "22px",
                    fontWeight: "600",
                  }}
                >
                  All Teams
                </span>
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="flex-end">
              <Grid item>
                <Link to={"/teams/add-team"}>
                  <Button
                    disableElevation
                    className="px-2"
                    size="large"
                    type="submit"
                    sx={{color: "rgb(0, 0, 0)" }}
                  >
                    <span className="mx-2">
                      <IoMdAddCircle color="rgb(244, 3, 20)" size={26} />
                    </span>
                    Add Team
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </div>
        </MainCard>
      </div> : <></>}

      {can_view_teams ? <MainCard>
        <Table
          dataSource={allTeamsData ?? []}
          columns={columns}
          pagination={false}
          loading={loading}
        />

        <div style={{ textAlign: "center", marginTop: 16 }}>
          <Pagination
            current={allTeamsData?.meta?.current_page || 1}
            total={allTeamsData?.meta?.total || 0}
            pageSize={allTeamsData?.meta?.per_page || 10}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </div>
      </MainCard> : <></>}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    allTeamsData: state?.AllTeamsReducer?.allTeams,
  };
};

export default connect(mapStateToProps)(AllTeams);
